export default {
  nav: {
    home: 'Startseite',
    about: 'Wir über uns',
    processing: 'Blechbearbeitung',
    contact: 'Kontakt',
    imprint: 'Impressum',
    cta: 'Anfrage senden',
  },
  footer: {
    tagline: 'Ihr leistungsstarker Partner rund um die Blech- und Metallverarbeitung. Präzise, sauber und zuverlässig.',
    exploreLabel: 'Navigation',
    contactLabel: 'Kontakt',
    addressLine1: 'S+N Blech- und Metallverarbeitungs GmbH',
    addressLine2: 'Beierfelder Str. 22',
    addressLine3: '08315 Lauter-Bernsbach',
    phone: 'Telefon',
    email: 'E-Mail',
    legalLabel: 'Rechtliches',
    rights: 'Alle Rechte vorbehalten.',
  },
  home: {
    hero: {
      badge: 'Metallverarbeitung seit 2001',
      titleLine1: 'Ihr Partner für',
      titleHighlight: 'Blech- und Metallverarbeitung',
      subtitle: 'Wir sind Ihr leistungsstarker Partner rund um die Metallverarbeitung. Auf dieser Seite stellen wir Ihnen unser Unternehmen und seine Leistungen vor.',
      ctaPrimary: 'Leistungen entdecken',
      ctaSecondary: 'Kontakt aufnehmen',
      scrollHint: 'Mehr erfahren',
    },
    stats: [
      { value: '2001', label: 'Gegründet in Bernsbach' },
      { value: '20+', label: 'Jahre Berufserfahrung' },
      { value: '100%', label: 'Zuverlässigkeit' },
      { value: '4', label: 'Kernkompetenzen' },
    ],
    intro: {
      eyebrow: 'Herzlich willkommen',
      title: 'Präzision aus Blech und Metall',
      p1: 'Wir sind Ihr leistungsstarker Partner rund um die Metallverarbeitung. Auf dieser Website möchten wir Ihnen unser Unternehmen und seine Leistungen vorstellen.',
      p2: 'Unsere Mitarbeiter bringen eine langjährige Berufserfahrung aus dieser Branche mit. Wir arbeiten schnell und sauber und sind absolut zuverlässig.',
      p3: 'Weitere Informationen zu unseren Produkten können Sie auch bequem per E-Mail anfordern.',
      point1: 'Alle gängigen Blecharten',
      point2: 'Fertigung nach Zeichnung und Muster',
      point3: 'Kurze Wege und direkte Ansprechpartner',
    },
    services: {
      eyebrow: 'Unsere Leistungen',
      title: 'Blechbearbeitung aus einer Hand',
      subtitle: 'Von der ersten Anfrage bis zum fertigen Bauteil begleiten wir Ihr Projekt mit Erfahrung und Sorgfalt.',
      items: [
        { title: 'Zuschnitt', desc: 'Passgenauer Zuschnitt aller gängigen Blecharten – nach Maß, Zeichnung oder Muster.' },
        { title: 'Stanzen', desc: 'Präzise Stanztechnik für Serienteile und individuelle Anforderungen.' },
        { title: 'Kanten & Biegen', desc: 'Sauberes Kanten und Biegen für formstabile, maßhaltige Bauteile.' },
        { title: 'Montagearbeiten', desc: 'Komplette Montage- und Vormontagearbeiten für Ihre Baugruppen.' },
      ],
      cta: 'Alle Leistungen ansehen',
    },
    why: {
      eyebrow: 'Warum S+N',
      title: 'Erfahrung, die man sehen kann',
      subtitle: 'Wir arbeiten schnell und sauber – und sind absolut zuverlässig.',
      items: [
        { title: 'Langjährige Erfahrung', desc: 'Seit 2001 in der Branche verwurzelt, mit jahrzehntelanger praktischer Erfahrung unseres Teams.' },
        { title: 'Absolut zuverlässig', desc: 'Schnelle, saubere Ausführung und verbindliche Termine – darauf können Sie sich verlassen.' },
        { title: 'Breites Materialwissen', desc: 'Ob Edelstahl, Stahl oder Aluminium – wir verarbeiten für Sie alle gängigen Blecharten.' },
      ],
    },
    process: {
      eyebrow: 'So arbeiten wir',
      title: 'In vier Schritten zum Bauteil',
      subtitle: 'Klar, direkt und ohne Umwege – von der Anfrage bis zur Lieferung.',
      steps: [
        { title: 'Anfrage', desc: 'Sie senden uns Ihre Anfrage inklusive Zeichnung, Muster oder Beschreibung.' },
        { title: 'Beratung', desc: 'Wir beraten Sie zu Material, Machbarkeit und passender Fertigung.' },
        { title: 'Fertigung', desc: 'Zuschnitt, Stanzen, Kanten und Montage – alles aus einer Hand.' },
        { title: 'Lieferung', desc: 'Zuverlässige Termine und saubere Übergabe Ihrer Bauteile.' },
      ],
    },
    gallery: {
      eyebrow: 'Einblicke',
      title: 'Ein Blick in unsere Fertigung',
      subtitle: 'Maschinen, Bauteile und Werkstücke aus unserem Alltag.',
      cta: 'Mehr Bilder ansehen',
    },
    cta: {
      title: 'Sprechen Sie uns an',
      subtitle: 'Falls Sie Fragen zu unseren Produkten haben, sprechen Sie uns an! Wir beraten Sie gerne zu Ihrem Projekt.',
      primary: 'Anfrage senden',
      secondary: 'info@sn-metall.de',
    },
  },
  about: {
    hero: {
      eyebrow: 'Wir über uns',
      title: 'Ein Familienunternehmen mit Geschichte',
      subtitle: 'Seit 2001 stehen wir für zuverlässige Blech- und Metallverarbeitung in Lauter-Bernsbach.',
    },
    story: {
      eyebrow: 'Unsere Geschichte',
      title: 'Gegründet 2001, gewachsen mit Erfahrung',
      p1: 'Unsere Firma wurde 2001 durch S. Schneider und seinen Partner als GmbH in Bernsbach gegründet.',
      p2: '2006 wurde Herr Schneider alleiniger Gesellschafter des Unternehmens.',
      p3: 'Seit 2015 erfolgte die schrittweise Übergabe an seine Tochter und Axel Friedrich wurde der neue Geschäftsführer.',
    },
    facts: {
      founded: 'Gegründet',
      management: 'Geschäftsführung',
      location: 'Standort',
    },
    timeline: {
      eyebrow: 'Meilensteine',
      title: 'Unsere Entwicklung',
      items: [
        { year: '2001', title: 'Gründung in Bernsbach', desc: 'S. Schneider und sein Partner gründen die S+N Blech- und Metallverarbeitungs GmbH.' },
        { year: '2006', title: 'Alleiniger Gesellschafter', desc: 'Herr Schneider übernimmt alle Anteile und führt das Unternehmen eigenständig weiter.' },
        { year: '2015', title: 'Generationswechsel', desc: 'Die schrittweise Übergabe an die Tochter beginnt – Axel Friedrich wird neuer Geschäftsführer.' },
      ],
    },
    management: {
      eyebrow: 'Geschäftsführung',
      title: 'Ihr Ansprechpartner',
      name: 'Axel Friedrich',
      role: 'Geschäftsführer',
      quote: 'Wir arbeiten schnell und sauber und sind absolut zuverlässig – dieses Versprechen geben wir bei jedem Auftrag.',
    },
    values: {
      eyebrow: 'Unsere Werte',
      title: 'Worauf Sie sich verlassen können',
      items: [
        { title: 'Erfahrung', desc: 'Langjährige Berufserfahrung aus der Metallverarbeitung in jedem Projekt.' },
        { title: 'Zuverlässigkeit', desc: 'Verbindliche Zusagen, saubere Arbeit und pünktliche Lieferung.' },
        { title: 'Qualität', desc: 'Präzise Verarbeitung und sorgfältige Kontrolle jedes Bauteils.' },
        { title: 'Partnerschaft', desc: 'Persönliche Beratung und direkte Ansprechpartner für Ihr Anliegen.' },
      ],
    },
  },
  processing: {
    hero: {
      eyebrow: 'Blechbearbeitung',
      title: 'Zuschnitt, Stanzen, Kanten, Montagearbeiten',
      subtitle: 'Wir verarbeiten für Sie alle gängigen Blecharten – präzise, sauber und termingerecht.',
    },
    intro: {
      eyebrow: 'Unsere Kompetenz',
      title: 'Falls Sie Fragen zu unseren Produkten haben, sprechen Sie uns an!',
      p1: 'Wir verarbeiten für Sie alle gängigen Blecharten – von der Einzelanfertigung bis zur Serie.',
      p2: 'Von Zuschnitt über Stanzen und Kanten bis hin zu Montagearbeiten erhalten Sie alle Arbeitsschritte aus einer Hand.',
    },
    capabilities: {
      eyebrow: 'Leistungen im Detail',
      title: 'Vier Kernkompetenzen',
      subtitle: 'Alles rund um die Blechbearbeitung – kompetent und aus einer Hand.',
      items: [
        { title: 'Zuschnitt', desc: 'Passgenauer Zuschnitt von Fein- und Grobblechen nach Maß, Zeichnung oder Muster.' },
        { title: 'Stanzen', desc: 'Stanztechnik für Serienteile, Lochbilder und individuelle Anforderungen.' },
        { title: 'Kanten & Biegen', desc: 'Formstabile Kantungen und Biegungen für maßhaltige Bauteile.' },
        { title: 'Montagearbeiten', desc: 'Montage und Vormontage kompletter Baugruppen nach Ihren Vorgaben.' },
      ],
    },
    materials: {
      eyebrow: 'Materialien',
      title: 'Alle gängigen Blecharten',
      subtitle: 'Wir verarbeiten für Sie die gängigen Werkstoffe der Blechbearbeitung.',
      items: ['Edelstahl', 'Stahl', 'Aluminium', 'Feinblech', 'Buntmetalle', 'Beschichtete Bleche'],
    },
    gallery: {
      eyebrow: 'Referenzen',
      title: 'Werkstücke aus unserer Fertigung',
      subtitle: 'Eine Auswahl an Bauteilen und Arbeiten aus unserem Betrieb.',
    },
  },
  contact: {
    hero: {
      eyebrow: 'Kontakt',
      title: 'Nehmen Sie Kontakt mit uns auf',
      subtitle: 'Lassen Sie sich zu unseren Produkten und Leistungen beraten. Unsere Mitarbeiter stehen Ihnen mit Rat und Tat zur Seite.',
    },
    info: {
      eyebrow: 'So erreichen Sie uns',
      title: 'Ihre Ansprechpartner in Lauter-Bernsbach',
      addressLabel: 'Anschrift',
      addressValue: 'Beierfelder Str. 22, 08315 Lauter-Bernsbach',
      phoneLabel: 'Telefon',
      emailLabel: 'E-Mail',
      hoursLabel: 'Erreichbarkeit',
      hoursValue: 'Mo – Fr: 07:00 – 16:00 Uhr',
    },
    form: {
      title: 'Anfrage senden',
      subtitle: 'Füllen Sie das Formular aus – wir melden uns schnellstmöglich bei Ihnen.',
      nameLabel: 'Name',
      namePlaceholder: 'Ihr Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre@email.de',
      phoneLabel: 'Telefon',
      phonePlaceholder: 'Optional',
      subjectLabel: 'Betreff',
      subjectOptions: ['Angebot anfordern', 'Beratung', 'Sonstiges'],
      messageLabel: 'Nachricht',
      messagePlaceholder: 'Beschreiben Sie kurz Ihr Anliegen …',
      submit: 'Anfrage absenden',
      submitting: 'Wird gesendet …',
      success: 'Vielen Dank! Ihre Anfrage wurde übermittelt. Wir melden uns bei Ihnen.',
      error: 'Es gab ein Problem beim Senden. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt eine E-Mail.',
      required: 'Bitte füllen Sie die Pflichtfelder korrekt aus.',
    },
  },
  imprint: {
    hero: {
      eyebrow: 'Rechtliches',
      title: 'Impressum',
      subtitle: 'Angaben gemäß § 5 TMG',
    },
    addressTitle: 'Anschrift',
    contactTitle: 'Kontakt',
    representativeTitle: 'Vertreten durch',
    registerTitle: 'Registereintrag',
    vatTitle: 'Umsatzsteuer-Identifikationsnummer',
    disclaimerTitle: 'Haftungsausschluss',
    disclaimer:
      'Die Inhalte dieser Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Für die Inhalte verlinkter externer Seiten sind ausschließlich deren Betreiber verantwortlich.',
  },
};